import React, { Component } from "react";
import ColorsSet, { colorYellow } from "../../../../../common/utils/StarColorSet";
import StarColorsListDropdown from "../../../../../common/components/input/StarColorsListDropdown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
export default class StarColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ?? "",
    };    
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.clearFocusedCell = this.clearFocusedCell.bind(this);
  }

  clearFocusedCell() {
    this.props.api.clearFocusedCell();
    this.props.api.clearRangeSelection();
  }

  handleChange = (e) => {
    this.props.onChange(e);
    if (this.state.value == "yellow" && e == "yellow") {
      this.props.colDef.store.handleCellValueChanged({
        colDef: this.props.colDef,
        api: this.props.api,
        node: this.props.node,
        newValue: e,
        oldValue: "",
      });
    }
  };

  handleClickOutside() {
    if (this.state.value == "yellow") {
      this.props.colDef.store.handleCellValueChanged({
        colDef: this.props.colDef,
        api: this.props.api,
        node: this.props.node,
        newValue: this.state.value,
        oldValue: "",
      });
    }
    this.props.api.stopEditing(false);
  }

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return true;
  }

  render() {
    return (
      <ClickAwayListener onClickAway={this.handleClickOutside} disableReactTree>
        <div>
        <StarColorsListDropdown
          colors={ColorsSet}
          colorYellow={colorYellow}
          onChange={this.handleChange}
          value={this.state.value}
          clearFocusedCell={this.clearFocusedCell}
          starAnchorEl={this.props.eGridCell}
        />
        </div>
      </ClickAwayListener>
    );
  }
}
